//====================================================
//  Function: Gallery
//====================================================
function fn_components_gallery(){
	if ($( '.js-gallery' ).length){
		$( '.js-gallery' ).lightGallery({
			selector: '.js-gallery-item',
			hash: false
		})

		$(document).on('click', '.js-gallery-btn' , function() {
			$('.js-gallery-main .first-image .js-gallery-item').trigger('click');
		});
	}
}